module.exports = __webpack_public_path__ + "img/Tela docx.8447f128.jpg";